const mutations = {
  getPaxelcoDashboard: (state, paxel_dashboard) => {
    state.paxel_dashboard = paxel_dashboard;
  },
  postPaxelcoDashboard: (state, new_paxel_dashboard) => {
    state.paxel_dashboard.push(new_paxel_dashboard);
  },
};

export default mutations;
